module.exports = __webpack_public_path__ + "static/media/mockups.1c55cf47.svg";